import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AdSliderComponent } from "./ad-slider/ad-slider/ad-slider.component";
import { HeroResolver } from "./app.resolver";
import { AuthGuardService } from "./common/services/auth-guard.service";
import { KaryakartaDashboardComponent } from "./karyakarta-dashboard/karyakarta-dashboard.component";
import { LayoutComponent } from "./layout/layout/layout.component";
import { MainDashboardComponent } from "./main-dashboard/main-dashboard.component";
import { CreateMenuComponent } from "./permission/create-menu/create-menu.component";
import { PermissionMgmtComponent } from "./permission/permission-mgmt/permission-mgmt.component";
import { BirthdayCreateComponent } from "./todays-birthday/birthday-create/birthday-create.component";
import { BirthdayListComponent } from "./todays-birthday/birthday-list/birthday-list.component";
import { UserProfileComponent } from "./UserManagement/user-profile/user-profile.component";
import { AddViewerComponent } from "./viewer-dashboard/add-viewer/add-viewer.component";
import { ViewerListComponent } from "./viewer-dashboard/viewer-list/viewer-list.component";
// import { EmailViewComponent } from './email/components/email-view/email-view.component';

const routes: Routes = [
  {
    path: "login",
    resolve: {
      instanceConfig: HeroResolver,
    },
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },

  {
    path: "public",
    resolve: {
      instanceConfig: HeroResolver,
    },
    loadChildren: () =>
      import("./public/public.module").then((m) => m.PublicModule),
  },
  {
    path: "ads/:id",
    component: AdSliderComponent,
    resolve: {
      instanceConfig: HeroResolver,
    },
  },
  {
    path: "layout",
    component: LayoutComponent,
    canLoad: [AuthGuardService],
  },

  {
    path: "",
    pathMatch: "full",
    redirectTo: "main-dashboard",
    canLoad: [AuthGuardService],
  },
  {
    path: "error",

    loadChildren: () =>
      import("./error-handler/error-handler.module").then(
        (m) => m.ErrorHandlerModule
      ),
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "admin-dashboard",
        canActivate: [AuthGuardService],
        resolve: {
          instanceConfig: HeroResolver,
        },
        loadChildren: () =>
          import("./a-dashboard/a-dashboard.module").then(
            (m) => m.ADashboardModule
          ),
        data: {
          menu: "SUPER_ADMIN_DASHBOARD",
        },
      },
      {
        path: "viewer-dashboard",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./viewer-dashboard/viewer-dashboard.module").then(
            (m) => m.ViewerDashboardModule
          ),
        data: {
          menu: "VIEWER_DASHBOARD",
        },
      },
      {
        path: "visitor",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./visitor/visitor.module").then((m) => m.VisitorModule),
      },
      {
        path: "advertisement",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./advertisement/advertisement.module").then(
            (m) => m.AdvertisementModule
          ),
      },
      {
        path: "repository",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./repository/repository.module").then(
            (m) => m.RepositoryModule
          ),
      },
      {
        path: "adhikari",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./adhikari/adhikari.module").then((m) => m.AdhikariModule),
      },
      {
        path: "connector",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./connector/connector.module").then((m) => m.ConnectorModule),
      },
      {
        path: "system-menu",
        canLoad: [AuthGuardService],
        loadChildren: () =>
          import("./system-menu/system-menu.module").then(
            (m) => m.SystemMenuModule
          ),
        data: {
          menu: "SYSTEM_MENU",
        },
      },
      {
        path: "provide-menu",
        canLoad: [AuthGuardService],
        loadChildren: () =>
          import("./provide-menu/provide-menu.module").then(
            (m) => m.ProvideMenuModule
          ),
        data: {
          menu: "PROVIDE_MENU",
        },
      },
      {
        path: "complain",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./complain-box/complain-box.module").then(
            (m) => m.ComplainBoxModule
          ),
      },
      {
        path: "office",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./office/office.module").then((m) => m.OfficeModule),
      },
      {
        path: "karyakarta",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./karyakarta/karyakarta.module").then(
            (m) => m.KaryakartaModule
          ),
      },
      {
        path: "register-book",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./register-book/register-book.module").then(
            (m) => m.RegisterBookModule
          ),
      },
      {
        path: "shedule-book",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./shedule-book/shedule-book.module").then(
            (m) => m.SheduleBookModule
          ),
      },
      {
        path: "kiosk",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./KIOSK/kiosk.module").then((m) => m.KioskModule),
      },
      {
        path: "duara",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./duara/duara.module").then((m) => m.DuaraModule),
      },
      {
        path: "report",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./report/report.module").then((m) => m.ReportModule),
      },
      {
        path: "todo",
        loadChildren: () =>
          import("./todo/todo.module").then((m) => m.TodoModule),
      },
      {
        path: "html-editor",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./html-editor/html-editor.module").then(
            (m) => m.HtmlEditorModule
          ),
      },
      {
        path: "vikas-kame",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./vikas-kame/vikas-kame.module").then(
            (m) => m.VikasKameModule
          ),
      },
      {
        path: "mla-fund-mgmt",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./mla-fund-mgmt/mla-fund-mgmt.module").then(
            (m) => m.MlaFundMgmtModule
          ),
      },
      {
        path: "super-admin",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./superadmin/super-admin.module").then(
            (m) => m.SuperAdminModule
          ),
      },
      {
        path: "global",
        canLoad: [AuthGuardService],
        loadChildren: () =>
          import("./global-search/global-search.module").then(
            (m) => m.GlobalSearchModule
          ),
        data: {
          menu: "GLOBAL",
        },
      },
      {
        path: "voter",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./voter-search/voter-search.module").then(
            (m) => m.VoterSearchModule
          ),
        data: {
          menu: "VOTER_SEARCH",
        },
      },
      {
        path: "single-window-entry",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./single-window-entry/single-window-entry.module").then(
            (m) => m.SingleWindowEntryModule
          ),
        data: {
          menu: "SINGLE_WINDOW_ENTRY",
        },
      },
      {
        path: "karyakarta/dashboard",
        canActivate: [AuthGuardService],
        component: KaryakartaDashboardComponent,
        data: {
          menu: "KARYAKARTA_DASHBOARD",
        },
      },
      {
        path: "user/viewer/create",
        canActivate: [AuthGuardService],
        component: AddViewerComponent,
        data: {
          menu: "MANAGE_VIEWER",
          feature: "ADD",
        },
      },
      {
        path: "user/viewer/list",
        canActivate: [AuthGuardService],
        component: ViewerListComponent,
        data: {
          menu: "MANAGE_VIEWER",
          feature: "LIST",
        },
      },

      {
        path: "user/viewer/edit/:id",
        canActivate: [AuthGuardService],
        component: AddViewerComponent,
        data: {
          menu: "MANAGE_VIEWER",
          feature: "UPDATE",
        },
      },
      {
        path: "user-profile",
        canLoad: [AuthGuardService],
        component: UserProfileComponent,
        data: {
          menu: "USER_PROFILE",
        },
      },
      {
        path: "permission-mgmt",
        canLoad: [AuthGuardService],
        component: PermissionMgmtComponent,
      },
      {
        path: "edit/:roleId",
        canLoad: [AuthGuardService],
        component: CreateMenuComponent,
      },
      {
        path: "create-menu",
        canLoad: [AuthGuardService],
        component: CreateMenuComponent,
      },
      {
        path: "todays-birthday/list",
        canActivate: [AuthGuardService],
        component: BirthdayListComponent,
        data: {
          menu: "TODAYS_BIRTHDAY",
          feature: "LIST",
        },
      },
      {
        path: "todays-birthday/create",
        canActivate: [AuthGuardService],
        component: BirthdayCreateComponent,
        data: {
          menu: "TODAYS_BIRTHDAY",
          feature: "ADD",
        },
      },
      {
        path: "system-menu",
        canActivate: [AuthGuardService],
        loadChildren: "./system-menu/system-menu.module#SystemMenuModule",
        data: {
          menu: "SYSTEM_MENU",
        },
      },
      {
        path: "call-log",
        canActivateChild: [AuthGuardService],
        loadChildren: "./call-logs/call-logs.module#CallLogsModule",
      },
      {
        path: "main-dashboard",
        canActivate: [AuthGuardService],
        component: MainDashboardComponent,
      },
      {
        path: "import-voter",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./voter/module/voter-import.module").then(
            (m) => m.VoterImportModule
          ),
        data: {
          menu: "IMPORT_VOTER_DATA",
        },
      },
      {
        path: "voter-search-config",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./voter-search/voter-search.module").then(
            (m) => m.VoterSearchModule
          ),
       
      },
      {
        path: "public-search-history",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./voter-search/voter-search.module").then(
            (m) => m.VoterSearchModule
          ),
       
      },
      {

        path: "enquiry",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./enquiry/enquiry.module").then((m) => m.EnquiryModule),
      },
      {
        path: "message-pannel",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./message-pannel/message-pannel.module").then(
            (m) => m.MessagePannelModule
          ),
      },
      {
        path: "manage-user",
        canActivateChild: [AuthGuardService],
        loadChildren: () =>
          import("./manage-user/manage-user.module").then(
            (m) => m.ManageUserModule
          ),
      },
      {
        path: "shared-list",
        loadChildren: () =>
          import("./shared-list/shared-list.module").then(
            (m) => m.SharedListModule
          ),
        data: {
          menu: "SHARED_LIST",
        },
      },
      {
        path:'donate',
        loadChildren: () => 
          import('./donate/donate.module'). then( (m) => m.DonateModule)
      },
      {
        path:'email',
        loadChildren:()=>
        import('./email/email.module').then((m) => m.EmailModule)
      },
      
      // { path: 'email-view', component: EmailViewComponent } 

      {
        path: 'meeting',
        loadChildren: () => import('./meeting/meeting.module').then(m => m.MeetingModule)
      }
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
